export const selectReducer = (state) => state.auth;

export const selectGlobalUserInfo = (state) =>
  selectReducer(state) ? selectReducer(state).get('user') : {};
